import _ from 'lodash'
import { NumberFormat } from '@/plugin/mixin/number-format'

let listeners = []

function focusListener(ev, binding) {
  console.log('focusListener', ev.target.value, binding)
  ev.target.value = NumberFormat.convertFormatToNumber(ev.target.value)
}

function blurListener(ev, binding) {
  console.log('blurListener', ev.target.value, binding)
  ev.target.value = NumberFormat.convertNumberToFormat(ev.target.value, binding.value)
}

function attachListener(el, eventName, callback) {
  el.addEventListener(eventName, callback)
  listeners.push({
    element: el,
    eventName: eventName,
    callback: callback
  })
}

export default {
  bind(el, binding) {
    attachListener(el, 'focus', (ev) => {
      focusListener(ev)
    })
    attachListener(el, 'blur', (ev) => {
      blurListener(ev, binding)
    })
  },
  unbind() {
    _.forEach(listeners, (listener) => {
      listener.element.removeEventListener(listener.eventName, listener.callback)
    })

    listeners = []
  }
}
